import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { googleLogin } from "../../../api/authApi";
import { useAuth } from "../../../context/AuthContext";

export default function GoogleAuthCallback() {
  const navigate = useNavigate();
  const started = useRef(false);
  const { login: authLogin } = useAuth();

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const code = new URLSearchParams(window.location.search).get("code");
    window.history.replaceState({}, "", window.location.pathname);

    if (!code) {
      navigate("/login?googleError=missing_code", { replace: true });
      return;
    }

    async function handleGoogleCallback() {
      try {
        const response = await googleLogin(code);
        authLogin(response.token);
        navigate("/dashboard", { replace: true });
      } catch (err) {
        console.error("Google login error:", err);
        alert(err.message || "Unexpected error during Google login.");
        navigate("/login", { replace: true });
      }
    }

    handleGoogleCallback();
  }, [navigate, authLogin]);

  return <div>Processing Google sign-in...</div>;
}
